var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.182a1.212 1.212 0 1 0 0 2.424 1.212 1.212 0 0 0 0-2.424Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.727 2.364a2.363 2.363 0 0 0-2.364 2.363v14.545a2.364 2.364 0 0 0 2.364 2.364h10.545a2.363 2.363 0 0 0 2.364-2.364V8.183a.606.606 0 0 0-.177-.428L14.245 2.54a.606.606 0 0 0-.429-.177h-7.09Zm-.814 1.549c.216-.216.509-.337.814-.337h6.84l4.857 4.858v4.784l-2.569-2.563a1.207 1.207 0 0 0-1.705 0L10.799 14l-1.55-1.546a1.207 1.207 0 0 0-1.705 0l-1.969 1.964v-9.69c0-.305.122-.598.338-.814Zm-.338 12.12v3.24a1.152 1.152 0 0 0 1.152 1.151h10.545a1.151 1.151 0 0 0 1.152-1.152v-4.438a.604.604 0 0 1-.246-.149l-3.176-3.168-3.35 3.344a1.207 1.207 0 0 1-1.706 0l-1.55-1.546-2.574 2.569a.603.603 0 0 1-.247.149Z"
  }))));
};
export default SvgImage;